export default "<div class=\"bgMenu\">\r\n    <menu-site [logobranca]=\"true\"></menu-site>\r\n</div>\r\n\r\n<router-outlet></router-outlet>"